import NavBar from "./NavBar";
import { getTokenInfo, logOut } from "../utils/Guard";

const NavBarMenu = () => {
  const userInfo = getTokenInfo();
  const logoutHandler = () => {
    logOut();
    window.location.href = "/home";
    window.location.reload();
    
  };
  
  return (
    <>
      <NavBar
        userName={userInfo.FullName}
        logoutHandler={logoutHandler}
        home="/"
      />
    </>
  );
};
export default NavBarMenu;
